module.exports = __webpack_public_path__ + "static/media/Ruler.a59a2d1c.png";